"use strict";

function clearLeadingWhitespace(text) {
  return text.replace(/^ +/g, "");
}
function clearTrailingWhitespace(text) {
  return text.replace(/ +$/g, "");
}
function stripRunsWhiteSpace(runs) {
  return runs.map(function (run, index) {
    var drawing = run.drawing || "";
    var previousRun = runs[index - 1] || {};
    if (run.whitespace && (index === 0 || index === runs.length - 1)) {
      return "";
    }
    if (run.whitespace && previousRun.endsWhitespace) {
      return "";
    }
    var newText = run.text;
    if (run.calc) {
      if (index === 0 || previousRun.endsWhitespace) {
        newText = clearLeadingWhitespace(newText);
      }
      if (index === runs.length - 1) {
        newText = clearTrailingWhitespace(newText);
      }
      if (run.text !== newText) {
        return drawing + run.calc(newText);
      }
    }
    return drawing + run.data;
  }).join("");
}
function isWhiteSpace(text) {
  return /^[\t\r\n ]*$/g.test(text);
}
function startsWhiteSpace(text) {
  return /^[\t\r\n ]+/.test(text);
}
function endsWhiteSpace(text) {
  return /[\t\r\n ]+$/.test(text);
}
function clearWhitespace(text) {
  return text.replace(/[\n\t\r ]+/g, " ");
}
function splitWhitespace(text) {
  var result = [];
  var i = 0;
  var nl, tab;
  while (i < text.length) {
    nl = text.indexOf("\n", i);
    tab = text.indexOf("\t", i);
    if (nl === -1 && tab === -1) {
      result.push(text.slice(i));
      i = text.length;
    } else if (nl === -1 || tab !== -1 && tab < nl) {
      result.push(text.slice(i, tab));
      result.push({
        type: "tab"
      });
      i = tab + 1;
    } else {
      result.push(text.slice(i, nl));
      result.push({
        type: "nl"
      });
      i = nl + 1;
    }
  }
  return result.filter(function (x) {
    return x;
  });
}
module.exports = {
  stripRunsWhiteSpace: stripRunsWhiteSpace,
  isWhiteSpace: isWhiteSpace,
  startsWhiteSpace: startsWhiteSpace,
  endsWhiteSpace: endsWhiteSpace,
  clearWhitespace: clearWhitespace,
  splitWhitespace: splitWhitespace
};